import { getAnchorId } from 'src/utils/getAnchorId';

/**
 * Within the html of the richtext we need to add the anchor id and to the H2 element.
 * We do this for the first H2 element in the richtext, so we can use it as a table of content item.
 * The anchor id is based on the text within the H2 element.
 * @param html - The html of the richtext.
 * @returns The enriched richtext with the anchor id and the title.
 */
export const enrichParagraphWithAnchorId = (html: string) => {
  const match = html.match(/<h2>(.*?)<\/h2>/);

  if (!match)
    return {
      anchorId: undefined,
      title: undefined,
      text: html,
    };

  const anchorId = getAnchorId(match[1]);
  const enrichedHTML = html.replace(/<h2>(.*?)<\/h2>/, `<h2 id=${anchorId}>$1</h2>`);

  return {
    anchorId: getAnchorId(match[1]),
    title: match[1],
    text: enrichedHTML,
  };
};
